import React from 'react';

const HelpPage = () => (
  <div>
    Please call 646-578-1040 or e-mail question with screenshots & version number to zhangkct@gmail.com.
  </div>
);

export default HelpPage;



// WEBPACK FOOTER //
// ./src/components/help/HelpPage.js